import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '@/api/hosts';
import { Role } from '@/api/queries/useGetRoles';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface CreateRoleData {
  name: string;
  permissions: string[];
}

export const useCreateRole = () => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation<Role, Error, CreateRoleData>({
    mutationFn: async (data: CreateRoleData) => {
      const response = await fetch(`${APIBaseChronos}/api/roles`, getFetchConfig({ method: FetchMethod.POST, data }));

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message ?? 'Failed to create role');
      }

      return response.json();
    },
    onSuccess: (newRole) => {
      queryClient.setQueryData([QueryEntity.Roles], (oldRoles: Role[] | undefined) => {
        return oldRoles ? [...oldRoles, newRole] : [newRole];
      });

      toast.success('Role created successfully');
    },
    onError: (error) => {
      toast.error(error.message ?? 'Failed to create role');
    },
  });
};
